import React, { useState, useEffect } from 'react';
import TodayTempDisplay from './TodayTempDisplay';
import EmotionChart from './EmotionChart';
import NavigationCard from './NavigationCard';
import '../styles/Dashboard.scss';

import _ from 'lodash';

const Dashboard: React.FC = () => {
  const [hasCompletedOnboardingState, setHasCompletedOnboardingState] = useState<boolean>(false);
  const userData: string | null = localStorage.getItem('user');
  let parsedUserData: object | any;
  if (userData) {
    parsedUserData = JSON.parse(userData);
  }

  useEffect(() => {
    if (_.get(parsedUserData, 'hasCompletedOnboarding') !== true) {
      setHasCompletedOnboardingState(true);
    }
  }, []);

  const cardCount = hasCompletedOnboardingState ? 5 : 4;

  return (
    <main className="dashboard app-container">
      <div className="dashboard__widgets">
        <div className="dashboard__widget-main">
          <TodayTempDisplay />
        </div>
      </div>

      <div className={`dashboard__actions card-count-${cardCount}`}>
        {hasCompletedOnboardingState && (
          <NavigationCard
            title="나의 마음 체크하기"
            description="나의 현재 마음 상태를 체크해요."
            linkTo="/onboarding"
            iconName="onboarding"
            cardColor="white"
            className="card-onboarding"
          />
        )}

        <NavigationCard
          title="심리검사"
          description="나의 마음 상태를 점검해보세요."
          linkTo="/tests"
          iconName="tests"
          cardColor="light"
          className="card-tests"
        />
        <NavigationCard
          title="Big-Five 성격 검사"
          description="나의 성격 유형을 알아보세요."
          linkTo="/big-five-test"
          iconName="big-five"
          cardColor="white"
          className="card-big-five"
        />
        <NavigationCard
          title="마음 온도 기록하기"
          description="마음 온도를 기록하고 변화를 살펴보세요."
          linkTo="/thermometer"
          iconName="thermometer"
          cardColor="dark"
          className="card-thermometer"
        />
        <NavigationCard
          title="전문가와 상담하기"
          description="마음, 전문가와 함께 이야기를 나누어요."
          linkTo="/counseling/new"
          iconName="counseling"
          cardColor="white"
          className="card-counseling"
        />
      </div>

      <div className="dashboard__chart">
        <EmotionChart />
      </div>
    </main>
  );
};

export default Dashboard;
